import { IParams } from "src/utils/build-url";

export const requestAllCountriesOrderedByContinent = (): IParams => {
    return {
        orderBy: "ASC",
        sortBy: "name"
    };
};